/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Referral_Friend_Code_PlaceholderInputs */

const en_mobile_referral_friend_code_placeholder = /** @type {(inputs: Mobile_Referral_Friend_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referral code`)
};

const es_mobile_referral_friend_code_placeholder = /** @type {(inputs: Mobile_Referral_Friend_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de referido`)
};

/**
* | output |
* | --- |
* | "Referral code" |
*
* @param {Mobile_Referral_Friend_Code_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_referral_friend_code_placeholder = /** @type {((inputs?: Mobile_Referral_Friend_Code_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Referral_Friend_Code_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_referral_friend_code_placeholder(inputs)
	return en_mobile_referral_friend_code_placeholder(inputs)
});